import { ILogger } from '@cian/logger';
import { IPublicationTokens } from '../types/reducers/publishTerms';
import { IAppState } from '../../AppModulesWrapper';

export const logPublicationTokens = (
  logger: ILogger,
  state: IAppState,
  publicationTokens: IPublicationTokens,
  description: string,
) => {
  if (!publicationTokens.publicationToken && !state.servicePickerWidgetV2.paidPublication.initial) {
    let url = 'window is undefined';

    if (typeof window !== 'undefined') {
      url = window.location.href;
    }

    logger.error(`Publication tokens in ${description}`, {
      publicationTokens: JSON.stringify(publicationTokens),
      offer: JSON.stringify(state.servicePickerWidget.offer),
      hostName: JSON.stringify(state.microfrontend.hostName),
      adaptiveSettings: JSON.stringify(state.servicePickerWidget.layout.adaptiveSettings),
      url,
    });
  }
};
